<script>
/**
 * 手动实现的缺点：
 * 1，大量的处理代码对业务逻辑有很强的侵入性 。
 * 2，每个页面都要有一堆重复逻辑，用插件只需要导入插件，绑定后就可轻松调用。
 * 3，需要手动处理数据映射和清理，非常麻烦。
 * */
import axios from 'axios'
export default {
  data() {
    /** 
     * 名称规则校验函数
     */
    function namRules(rule, value, callback) {
      const asyncError = errorFields['name']
      if (!value) {
        callback(new Error('请输入名称'));
      } else if (asyncError && typeof asyncError === 'string') {
        callback(new Error(asyncError));
      } else {
        callback();
      }
    }

    /** 
     * 性别校验函数
     */
    function genderRules(rule, value, callback) {
      const asyncError = errorFields['gender']
      if (!value) {
        callback(new Error('请选择性别'));
      } else if (asyncError && typeof asyncError === 'string') {
        callback(new Error(asyncError));
      } else {
        callback();
      }
    }

    /** 
     * 年龄校验函数
     */
    function ageRules(rule, value, callback) {
      const asyncError = errorFields['age']
      if (!value) {
        callback(new Error('请输入年龄'));
      } else if (asyncError && typeof asyncError === 'string') {
        callback(new Error(asyncError));
      } else {
        callback();
      }
    }

    return {
      formData: {
        name: '',
        age: '',
        gender: ''
      },
      namRules,
      genderRules,
      ageRules,
      errorFields: {},
      itemBarMap: {
        name: 'itemNameBar',
        gender: 'itemGenderBar',
        age: 'itemAgeBar'
      }
    }
  },

  methods: {
    claerAsyncError(field) {
      /** 判断是否是清空指定filed的async error */
      if (field && typeof field === 'string') {
        this.errorFields[field] = undefined
        const itemBarName = this.errorFields[field]
        /** 清理指定field的error对象事件触发后，需要重置该指定field的显示 */
        itemBarName && typeof itemBarName === 'string' && this.$refs[itemBarName].resetFields()
      } else {
        /** 清空所有 error */
        for (const key in this.errorFields) {
          this.errorField[key] = undefined
        }
        /** 所有error对象添加后，需要触发整体ID */
        this.$refs['formRefBar'].resetFields()
      }
    },
    /** 添加错误信息到async error对象 */
    addErrorToErrorDatas(formError) {
      /** 遍历返回的错误对象，将错误数据存储上去  */
      formError.forEach(item => {
        const msg = item.msg
        if (!msg) return
        this.errorFields[item.key] = msg
      });
    },
    /** 根据 errorFields将存在的error field触发校验并显示在页面上 */
    emitAsyncErrorValidator() {
      for (const key in this.errorFields) {
        if (!key || typeof key != 'string') continue
        this.$refs['formRefBar'].validateField(key)
      }
    },
    async submitFunciton() {
      this.claerAsyncError() /** 清空之前的 */
      const valid = await this.$refs['formRefBar'].validate()
      if (!valid) return console.log('本地校验错误')
      axios.post('/xxx/xxx').then(res => {
        if (res.form_error) {
          this.addErrorToErrorDatas(res.formError)
          this.emitAsyncErrorValidator()
          console.log('完成远端校验映射')
          return false;
        }
        console.log('提交成功')
      });
    }
  },
  render(h) {
    return (
      <el-form ref="formRefBar">
        <el-form-item ref="itemNameBar" prop="name" label="姓名" rules={[{ validator: this.namRules, trigger: 'blur' }]}>
          <el-input vModel={this.formData.name} onFocus={this.claerAsyncError('name')}></el-input>
        </el-form-item>
        <el-form-item ref="itemGenderBar" prop="gender" label="性别" rules={[{ validator: this.genderRules, trigger: 'change' }]}>
          <el-select vModel={this.formData.gender} onChange={this.claerAsyncError('gender')}>
            <el-option label="1">男</el-option>
            <el-option label="2">女</el-option>
          </el-select>
        </el-form-item >
        <el-form-item ref="itemAgeBar" prop="age" label="年龄" rules={[{ validator: this.ageRules, trigger: 'blur' }]}>
          <el-input vModel={this.formData.age} onFocus={this.claerAsyncError('age')}></el-input>
        </el-form-item>
        <el-button onClick={this.submitFunciton()}> 提交</el-button >
      </el-form>
    );
  }
};
</script>
